import { createSlice } from '@reduxjs/toolkit';
import {
  getCategories,
  getSubcategoriesByCategoryId,
} from 'services/categories';
import { AppThunkAction } from '../../store';
import { ICategoryState } from './categoriesTypes';

const initialState: ICategoryState = {
  categories: undefined,
  subcategories: undefined,
  filter: undefined,
  currentCategoryId: undefined,
  selectedCategories: undefined,
};

export const categoriesReducer = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    fetchCategories: (state, action) => {
      return {
        ...state,
        categories: action.payload,
      };
    },
    fetchSubcategories: (state, action) => {
      return {
        ...state,
        subcategories: action.payload,
      };
    },
    resetSubcategories: (state) => {
      return {
        ...state,
        subcategories: undefined,
      };
    },
    setCurrentCategoryId: (state, action) => {
      return {
        ...state,
        currentCategoryId: action.payload,
      };
    },
    setSelectedCategory: (state, action) => {
      return {
        ...state,
        selectedCategories: action.payload,
      };
    },
    resetSelectedCategory: (state) => {
      return {
        ...state,
        selectedCategories: undefined,
      };
    },
  },
});

export const {
  fetchCategories,
  fetchSubcategories,
  resetSubcategories,
  setCurrentCategoryId,
  setSelectedCategory,
  resetSelectedCategory,
} = categoriesReducer.actions;

export default categoriesReducer.reducer;

export const getCategory = (): AppThunkAction => async (dispatch) => {
  try {
    const categories = await getCategories();
    dispatch(fetchCategories(categories));
  } catch (e) {
    if (e instanceof Error) {
      throw e;
    }
  }
};

export const getSubcategories =
  (categoryId: number): AppThunkAction =>
  async (dispatch) => {
    try {
      const subcategories = await getSubcategoriesByCategoryId(categoryId);
      dispatch(fetchSubcategories(subcategories));
    } catch (e) {
      if (e instanceof Error) {
        throw e;
      }
    }
  };
